/**
 * Created by luo on 03/09/2020.
 */
'use strict';

angular.module('bookManagement', ['adf.provider'])
  .config(function ($stateProvider) {
    $stateProvider.state('books', {
      parent: 'betotrack',
      abstract: true,
      url: '/book',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('books.list', {
      url: '/list',
      views: {
        'content@app': {
          controller: 'bookManangementCtrl',
          templateUrl: 'components/track/admin/bookManagementList.tpl.html'
        }
      },
      ncyBreadcrumb: {
        label: 'booksList.moduleName'
      }
    }).state('books.add', {
      url: '/add',
      views: {
        'content@app': {
          controller: 'bookManagementAddEditCtrl',
          templateUrl: 'components/track/admin/bookManagementAddEdit.tpl.html'
        }
      },
      resolve: {
        editorModel: function () {
          return {
            mode: 'new',
          };
        }
      },
      ncyBreadcrumb: {
        parent: 'books.list',
        label: 'contactNew.new'
      }
    }).state('books.edit', {
      url: '/edit',
      views: {
        'content@app': {
          controller: 'bookManagementAddEditCtrl',
          templateUrl: 'components/track/admin/bookManagementAddEdit.tpl.html'
        }
      },
      resolve: {
        editorModel: function () {
          return {
            mode: 'edit',
          };
        }
      },

      ncyBreadcrumb: {
        parent: 'books.list',
        label: 'contactNew.edit'
      }
    });
  })
  .controller('bookManangementCtrl', function ($scope, $timeout, $translate, $uibModal, commonTrackService, widgetSettingsCreatorService, bookManangementService, $state) {

    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.isDataAvailable = false;
    $scope.isListEmpty = true;
    $scope.bookManagementDetails = {
      selectedFunction: ''
    };
    $scope.dataLoading = true;


    // More functions Start
    var deleteBook = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'components/track/telephone/deleteConfirm.tpl.html',
        controller: 'bookManagementDeleteCtrl',
        resolve: {
          selectedRowData: function () {
            return {};
          }
        }
      });
      modalInstance.result.then(function (result) {
        var gridName = '#' + $scope.overviewGridPrefix + 'booksList';
        if (result === 'success') {
          var rowindex = $(gridName).jqxGrid('getselectedrowindex');
          if (rowindex > -1) {
            var id = $(gridName).jqxGrid('getrowid', rowindex);
            $(gridName).jqxGrid('deleterow', id);
          }

          if($(gridName).jqxGrid('source').records.length === 0){
            // list is empty
            $scope.isListEmpty = true;
          } else{
            // select first row in list
            $(gridName).jqxGrid('selectrow', 0);
          }

        } else if (result === 'error') {
          console.log('delete error');
        }
      });
    };

    var downloadFunction = function () {
      $uibModal.open({
        templateUrl: 'components/track/admin/bookDownload.tpl.html',
        controller: 'bookManagementDownloadCtrl'
      });
    };

    $scope.moreFunctionsSource = [{
      name: $translate.instant('moreFunction.functionList.download'),
      operation: 'download',
      disabled: true,
      execute: downloadFunction
    }, {
      name: $translate.instant('moreFunction.functionList.delete'),
      operation: 'delete',
      disabled: true,
      execute: deleteBook
    }];

    $scope.moreFuctionSetting = {
      placeHolder: $translate.instant('moreFunction.button.function'),
      displayMember: 'name',
      valueMember: 'operation',
      source: $scope.moreFunctionsSource,
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      width: '200px',
      height: 30,
      autoDropDownHeight: true
    };

    $scope.moreFunctions = function () {
      for (var index in $scope.moreFunctionsSource) {
        var moreFunctionsItem = $scope.moreFunctionsSource[index];
        if (moreFunctionsItem.operation && moreFunctionsItem.operation === $scope.bookManagementDetails.selectedFunction.operation) {
          moreFunctionsItem.execute();
          $scope.bookManagementDetails.selectedFunction = '';
          break;
        }

        moreFunctionsItem = moreFunctionsItem;
      }
      $('#moreFunDropDown').jqxDropDownList('clearSelection');
    };

    // More functions End

    // BookListGrid start

    $scope.customGridProperties = {
      pagesize: 25,
      height: 600,
      autoheight: false,
      showfilterrow: true,
      filterable: true,
      columns: []
    };

    $scope.bookListRowSelectHandler = function (event) {
      if (event.type === 'rowselect' && event.args.row) {
        var selectedRow = event.args.row;
        bookManangementService.setSelectedBook({
          identifier: selectedRow.bookidentifier,
          displayName: selectedRow.bookdisplayname,
          row: selectedRow
        });
      }
    };

    var _tmpColumnProperties = [{
      name: 'displayName', width: '25%',
      type: 'string'
    }];

    $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, { moduleName: 'books' });
    var _additionalProperties = { translatedName: $translate.instant('booksList.moduleName') };
    //$scope.booksListGridSettings = commonTrackService.getGridSettings('booksGrid', $scope.customGridProperties, null, _additionalProperties);

    var getBookList = function () {
      var booksListSource =
      {
        datatype: 'array',
        datafields: [],
        localdata: [],
        sort: null
      };

      var requestParam = {
        dataRefresh: true,
        reportOptions: {}
      };

      var param = {
        'filter': JSON.stringify(requestParam)
      };

      return bookManangementService.getBookList(param).then(function (bookIndexes) {
        $scope.isDataAvailable = true;

        if(bookIndexes.dataList && bookIndexes.dataList.length > 0){
          $scope.isListEmpty = false;
        } else {
          $scope.isListEmpty = true;
        }

        if (!$scope.bookListdataAdapter) {
          $scope.customGridProperties.columns = commonTrackService.getColumnProperties(bookIndexes.gridSettings.overviewListGrids[0].columnProperties, bookIndexes.columnTranslation, { moduleName: 'books' });
          $scope.booksListGridSettings = commonTrackService.getGridSettings('books', $scope.customGridProperties, null, _additionalProperties);
          booksListSource.localdata = bookIndexes.dataList;
          $scope.bookListdataAdapter = new $.jqx.dataAdapter(booksListSource);
          $scope.booksListGridSettings.source = $scope.bookListdataAdapter;
        } else {
          booksListSource.localdata = bookIndexes.dataList;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'booksList');
        }

      }, function (errorReponse) {
        if (errorReponse.data && errorReponse.data.message) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {
        if (!$scope.dataLoadingFinished) {
          $scope.dataLoadingFinished = true;
        }
      });

    };

    $scope.new = function () {
      $state.go('books.add');
    };

    $scope.edit = function () {
      $state.go('books.edit');
    };

    $scope.permissions = {};




    var checkBookPermission = function(){
      $scope.dataLoading = true;
      return bookManangementService.getBookListAclRight().then(function(permission){
        $scope.permissions.bookACL= permission;
      }, function(){
        // handle error
        $scope.permissions.bookACL= {aclRightLvel : 0};
      });
    };

    var checkBookDownPermission = function(){

      return bookManangementService.getBookDownloadAclRight().then(function(permission){
        $scope.permissions.bookDownloadACL = permission;
      }, function(){
        // handle error
       $scope.permissions.bookDownloadACL= {aclRightLvel : 0};
     });
    };

    checkBookPermission().then(function(){
      if($scope.permissions.bookACL && $scope.permissions.bookACL.aclRightLvel > 0){
        return  getBookList().then(function(){
          return checkBookDownPermission();
        }, function(){
          // handle error
          $scope.permissions.bookACL= {aclRightLvel : 0};
        });
      }
    }).finally(function(){
      $scope.dataLoading = false;
      if($scope.permissions.bookACL && $scope.permissions.bookACL.aclRightLvel > 0){
        // enable more options > delete
        $scope.dataLoading = false;
        if($scope.permissions.bookACL.aclRightLvel === 3){
          enableDropDown(1);
        } else {
          disableDropDown(1);

        }
        // enable more options > download
        if($scope.permissions.bookDownloadACL.aclRightLvel === 3 && $scope.permissions.bookACL.aclRightLvel === 3){
          enableDropDown(0);
        } else {
          disableDropDown(0);
        }
      }
    });

    function enableDropDown(index) {
      $timeout(function () {
        $('#moreFunDropDown').jqxDropDownList('enableAt', index); // this does not working check onece more
      },0,false );
    }

    function disableDropDown(index) {
      $timeout(function () {
        $('#moreFunDropDown').jqxDropDownList('disableAt', index); // this does not working check onece more
      },0,false );
    }

    // BookListGrid end

  })
  .controller('bookManagementAddEditCtrl', function ($scope, $translate, $state, editorModel, bookManangementService, commonTrackService, toastService) {
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.bookDetail = {
      identifier: '',
      displayName: ''
    };
    $scope.saveInProgress = false;

    $scope.cancel = function () {
      $state.go('books.list');
    };

    $scope.save = function (isStayOnSave) {
      $scope.saveInProgress = true;
      $scope.saveSuccessful = false;
      var allocations = $scope.bookAllocationListGridSettings.source.records;
      var originalAllocations = $scope.bookAllocationListGridSettings.source.originaldata;
      bookManangementService.saveBook($scope.bookDetail, allocations, originalAllocations).then(function () {
        if (isStayOnSave) {
          $scope.bookDetail = {
            identifier: 'newBook',
            displayName: ''
          };

          // De-allocate all allocations for new book creation.
          // Refetches the list to check for new contacts
          getBookAllocations($scope.bookDetail.identifier);
        }
        $scope.saveSuccessful = true;
        toastService.showSuccessToast($translate.instant('booksList.saveSuccess'));
      }, function (response) {
        console.error('Error saving Book: ', response);
        toastService.showErrorToast({message: $translate.instant('booksList.saveError'), type: 'F'});
      }).finally(function () {
        $scope.saveInProgress = false;
        if ($scope.saveSuccessful && !isStayOnSave) {
          $scope.cancel();
        }
      });
    };

    $scope.customGridProperties = {
      pagesize: 25,
      height: 600,
      autoheight: false,
      showfilterrow: true,
      filterable: true,
      editable: true,
      columns: []
    };

    var _tmpColumnProperties = [{
      name: 'displayName', width: '25%',
      type: 'string'
    }];

    $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, { moduleName: 'bookAllocations' });
    var _additionalProperties = { translatedName: $translate.instant('booksList.allocationList') };
    //$scope.bookAllocationListGridSettings = commonTrackService.getGridSettings('bookAllocationListGrid', $scope.customGridProperties, null, _additionalProperties);

    $scope.setAllAllocations = function(selected){
      for (var j = 0; j < $scope.bookAllocationListGridSettings.source.records.length; j++) {
        $scope.bookAllocationListGridSettings.source.records[j].contactassigned = selected;
      }
      $('#' + $scope.overviewGridPrefix +'bookAllocationsList').jqxGrid('refresh');
    };


    var getBookAllocations = function (bookID) {

      $scope.bookAllocationListSource = {
        datatype: 'array',
        datafields: [],
        localdata: [],
        sort: null
      };
      bookID = bookID;
      var requestParam = {
        dataRefresh: true,
        reportOptions: {},
        //reportOptions: {'test' : bookID},
        reportOption: bookID
      };

      var param = {
        'filter': JSON.stringify(requestParam)
      };

      return bookManangementService.getBookAllocationsForSelectedBook(param).then(function (allocations) {
        $scope.isDataAvailable = true;

        $scope.customGridProperties.columns = commonTrackService.getColumnProperties(allocations.gridSettings.overviewListGrids[0].columnProperties, allocations.columnTranslation, { moduleName: 'bookAllocations' });
        $scope.bookAllocationListGridSettings = commonTrackService.getGridSettings('bookAllocations', $scope.customGridProperties, null, _additionalProperties);
        $scope.bookAllocationListSource.localdata = allocations.dataList;
        if(!$scope.bookAllocationListdataAdapter){
          $scope.bookAllocationListGridSettings.pagesize = 15;
        }
        $scope.bookAllocationListdataAdapter = new $.jqx.dataAdapter($scope.bookAllocationListSource);
        $scope.bookAllocationListGridSettings.source = $scope.bookAllocationListdataAdapter;

      }, function (errorReponse) {
        console.error(errorReponse);
        if (errorReponse.data && errorReponse.data.message) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {
        if (!$scope.dataLoadingFinished) {
          $scope.dataLoadingFinished = true;
        }
      });
    };

    if (editorModel.mode === 'new') {
      $scope.bookDetail = {
        identifier: 'newBook',
        displayName: ''
      };

    } else {
      $scope.bookDetail = bookManangementService.getSelectedBook();
    }

    $scope.permissions= {};

    var checkBookPermission = function(){
      return bookManangementService.getBookListAclRight().then(function(permission){
        $scope.permissions.bookACL= permission;
      });
    };

    var checkContactsPermission = function(){
      return bookManangementService.getContactAclRight().then(function(permission){
        $scope.permissions.contactsACL = permission;
      });
    };

    checkBookPermission().then(function(){
      return checkContactsPermission();
    }).then(function(){
      if($scope.permissions.contactsACL.aclRightLvel === 0){
        // dont get allocation list
        return;
      }
      return getBookAllocations($scope.bookDetail.identifier);
    });



  })
  .controller('bookManagementDownloadCtrl', function ($scope, commonTrackService, widgetSettingsCreatorService, $uibModalInstance, bookManangementService, $timeout, $translate, errorHandlingService, toastService) {
    $scope.visibility = true;

    $scope.vehicleGroupComboBoxSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID',
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
      selectedIndex: 0,
      change: function (event) {
        var args = event.args;
        var vehicleGroupItem = $('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');
        if (args && vehicleGroupItem) {
          var groupId = vehicleGroupItem.value;
          loadVehicle(groupId);
        }
      }
    });

    var loadVehicle = function (groupId) {
      return commonTrackService.getVehicleListFilterByGroupId(groupId).then(function (vehicleList) {
        $scope.vehicleNameListBoxSettings.source = _.uniq(vehicleList, 'deviceID');
      });
    };

    var loadVehicleGroup = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (vehicleGroupList) {
        $scope.vehicleGroupComboBoxSettings.source = vehicleGroupList;
      });
    };

    var loadBookList = function(){
      var requestParam = {
        dataRefresh: false,
        reportOptions: {}
      };

      var param = {
        'filter': JSON.stringify(requestParam)
      };

      return bookManangementService.getBookList(param).then(function(data){
        $scope.bookListBoxSettings.source = data.dataList;
      });
    };

    $timeout(function () {
      $('#vehicleNameListBox').on('checkChange', function (event) {
        var item = event.args;
        if (item) {
          if (item.checked) {
            $timeout(function () {
              $scope.visibility = false;
            });
          } else {
            var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
            if (checkedItems.length === 0) {
              $timeout(function () {
                $scope.visibility = true;
              });
            } else {
              $scope.visibility = false;
            }
          }
        }
      });
    },0,false );

    $scope.vehicleNameListBoxSettings = {
      displayMember: 'description',
      valueMember: 'deviceID',
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
      checkboxes: true
    };

    $scope.bookListBoxSettings = {
      displayMember: 'bookdisplayname',
      valueMember: 'bookidentifier',
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
      checkboxes: true
    };

    loadBookList();

    loadVehicleGroup().then(function () {
      var vehicleGroupSource = $scope.vehicleGroupComboBoxSettings.source;
      if (vehicleGroupSource !== null && vehicleGroupSource !== undefined) {
        loadVehicle(vehicleGroupSource[0].groupID);
      }
    }).finally(function () {
      $scope.dataLoadingFinished = true;
    });

    $scope.selectAll = function (id) {
      $('#' + id).jqxListBox('checkAll');
    };

    $scope.deselectAll = function (id) {
      $('#' + id).jqxListBox('uncheckAll');
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.save = function () {
      var downloadParams = {
        deviceIds: [],
        bookIds: [],
        commandType: 'config',
        commandID: 'TEL',
        sendState: 0
      };
      var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
      var deviceIds = [];
      for (var i = 0; i < checkedItems.length; i++) {
        var item = checkedItems[i];
        deviceIds.push(item.value);
      }
      downloadParams.deviceIds = deviceIds;
      var checkedBookItems = $('#bookListBox').jqxListBox('getCheckedItems');
      var bookIds = [];
      for (var j = 0; j < checkedBookItems.length; j++) {
        var bookitem = checkedBookItems[j];
        bookIds.push(bookitem.value);
      }
      downloadParams.bookIds = bookIds;
      bookManangementService.downloadRequest(downloadParams).then(function () {
        $uibModalInstance.close();
        toastService.showSuccessToast($translate.instant('download.success'));
      }, function (response) {
        $uibModalInstance.close();
        errorHandlingService.handleForCommonResponse(response);
      });
    };

  })
  .controller('bookManagementDeleteCtrl', function($scope, $uibModalInstance, $state, errorHandlingService, bookManangementService){
    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };
    $scope.onKeyPress = function ($event) {
      if ($event.keyCode === 13) {
        $scope.delete();
      }
    };

    $scope.delete = function () {
      var bookDetail = bookManangementService.getSelectedBook();
      bookManangementService.deleteBook(bookDetail.identifier).then(function () {
        $uibModalInstance.close('success');
        $state.go('books.list');
      },function(response) {
        $uibModalInstance.close('error');
        errorHandlingService.handleForCommonResponse(response);
      });
    };

  })
  .service('bookManangementService', function (crudService) {
    var model = 'admin';

    this.selectedBook = {};

    this.setSelectedBook = function (bookDetails) {
      this.selectedBook = bookDetails;
    };

    this.getSelectedBook = function () {
      return this.selectedBook;
    };

    this.getBookAllocationsForSelectedBook = function (param) {
      return crudService.customGET(model, 'bookallocations', param);
    };

    this.getBookList = function (param) {
      return crudService.customGET(model, 'booklist', param);
    };

    this.saveBook = function (bookDetails, allocations, originalAllocations) {

      var allocationsToAdd = [];
      var allocationsToDelete = [];
      for (var i = 0; i < allocations.length; i++) {
        var allo = allocations[i];
        var oldAllo = originalAllocations[i];
        var newAllo = {
          bookidentifier: allo.bookidentifier,
          contactidentifier: allo.contactidentifier
        };

        if (allo.contactassigned !== oldAllo.contactassigned) {
          if (allo.contactassigned) {
            allocationsToAdd.push(newAllo);
          } else {
            allocationsToDelete.push(newAllo);
          }
        }
      }

      var bookPostObj = {
        bookDetails: {
          bookidentifier: bookDetails.identifier,
          bookdisplayname: bookDetails.displayName
        },
        newAllocaitons: allocationsToAdd,
        removedAllocaitons: allocationsToDelete
      };
      return crudService.post(model + '/book', bookPostObj);
    };

    this.downloadRequest = function (param) {
      return crudService.post('pendingcommands', param);
    };

    this.deleteBook = function(bookIdentifier){
      return crudService.delete(model + '/book?key=' + encodeURIComponent(bookIdentifier));
    };

    this.getBookListAclRight = function(){
      return  crudService.get(model+'/booklistaclright');
    };

    this.getBookDownloadAclRight = function(){
      return  crudService.get(model+'/pendingcmndaclright');
    };

    this.getContactAclRight= function(){
      return  crudService.get(model+'/contactsaclright');
    };


  });



// WEBPACK FOOTER //
// ./.tmp/components/track/admin/bookManagement.js